module.exports = __webpack_public_path__ + "static/media/daftar_peserta_ekskul.a4c752c3.png";